export default __webpack_public_path__ + "static/media/RecommendedContactActive.82714939.svg";